<template>
  <!-- 
    @Author shirleywanghui@didichuxing.com
    @Date 2022-04-26
    @Description cgc推荐页改版 - 分享区域 - button其他渠道
  -->
    <div class="xtc-share-button-other-channel" @click.stop="systemEntrance">
      <span class="other_channel">{{$t('FoodC_CGC_Other_channel_oFak' /** 其他渠道邀请 */)}}</span>
    </div>
</template>
<script>
export default {
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {}
  },
  computed: {},
  methods: {
    // 。。。埋点/调用bridge
    async shareCommon (plantform, bridgMethod, config) {
      this.$emit('trackShareButtonClick', 2)
      let shareConfig = {...config}
      // 分享whatsapp、facebook、Mycenter、调面板都不支持回调, 不做回调处理
      await this.SodaBridge(bridgMethod, {
        url: shareConfig.url,
        title: shareConfig.title,
        content: shareConfig.content,
        icon: shareConfig.icon
      })
      // .then((res) => {
      //   if (res && res.errno === 0) {
      //     this.isShow = true
      //   }
      // })
    },
    async systemEntrance () {
      // systemEntrance shareSystemEntrance
      /*
        content: "Hola, tu amigo te ha enviado MX$130.00 de descuento para tu primer pedido. Obténlo aquí:"
        icon: "https://img0.didiglobal.com/static/soda_public/do1_iTpDyAZqNJwcl87LRrhU"
        title: "¡Hasta MX$130.00 OFF en tu primer pedido!"
        url: "https://didi-food.onelink.me/ssCr/redeemCode?code=FOOD-J82RPF&activityType=1&
      */
      let config = this.config.config.systemEntrance || this.config.config.common
      await this.shareCommon('systemEntrance', 'shareSystemEntrance', config)
    }
  }
}
</script>
<style scoped lang="stylus">
.xtc-share-button-other-channel {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 638px;
  height: 88px;
  border: 1px solid #FF7A45;
  border-radius: 12px;
  .other_channel {
    // font-family: DiDiSansPro-Medium;
    font-family: Aspira Medium;
    font-size: 36px;
    color: #FF7A45;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
  }
}
</style>